import { type PageMenuItem } from '../types'

type MenuItemWithSubmenu = PageMenuItem & { items: PageMenuItem[] }

export const hasSubMenu = (item: PageMenuItem): item is MenuItemWithSubmenu =>
  item.items !== undefined && item.items.length > 0
